import { CaretUpOutlined, CaretDownOutlined, CloseCircleOutlined, SearchOutlined, PlusCircleOutlined, LockOutlined, UserOutlined, CreditCardOutlined, MailOutlined, PhoneOutlined, EditOutlined, DeleteOutlined, FileExcelOutlined } from '@ant-design/icons';
import { Col, DatePicker, Form, InputRef, List, Row } from 'antd';
import { Button, Input, Space, Table, Modal, InputNumber, Select, Drawer } from 'antd';
import type { ColumnsType, ColumnType } from 'antd/es/table';
import type { FilterConfirmProps, TableRowSelection } from 'antd/es/table/interface';
import React, { useRef, useState, useEffect } from 'react';
import style from './Tables.module.scss'
import { connect } from 'react-redux';
import { AppState } from '../../../store';
import { useHistory } from "react-router-dom";
import { RegisterUser, Rol, UserState } from '../../../store/user/types';
import moment from 'moment';
import {
    getAllEstablishmentTable, postResgisterEstablishment, putResgisterEstablishment,
    getEstablishmentByCode, putActiveEstablishment, deleteEstablishmentById, getAllEstablishmentTableByUser,

    deleteEstablishmentMethodById,
    getAllEstablishmentTableByOrganization,
    getAllGeiEstablishment,
    GetSelectableEstablishmentGeiInventoryByOrganizationId,
    PostEstablismentGei,
    DeleteEstablishmentGeiInventoryById,
    GetEstablishmentGeiInventoryById,

} from '../../../store/establishment/thunks';
import { getAllEstablishmentByGeiInventoryId, postResgisterEstablishmentGeiInventor } from '../../../store/geiInventory/thunks';
import { SizeType } from 'antd/es/config-provider/SizeContext';
import { validateIdentification, validateLetters, validatePhoneEC, validateBirthday, validateNumber, validateYear4, validate125, validate150, validate255 } from '../../../globals/Inputs/validateInput';
import validateMessages from '../../../globals/Inputs/validateMessages';
import { typesIdentification } from '../../../globals/Parameters/listParameters';
import TextArea from 'antd/es/input/TextArea';
import locale from 'antd/lib/date-picker/locale/es_ES';
import { Organization } from '../../../store/organization/types';
import { openNotification } from '../../../globals/Components/Notification/Notificaction';
import { getAllGeiInventoryFilter, getGeiInventoryById } from '../../../store/geiInventory/thunks';
import { GeiInventory } from '../../../store/geiInventory/types';
import { Establishment, EstablishmentDataType } from '../../../store/establishment/type';
import { EstablishmentGeiInventoryDataType } from '../../../store/geiInventory/types';
import { TablePaginationConfig } from 'antd/lib/table/interface';
import { getUserByToken } from '../../../store/user/thunks';
import { useLocation, useParams } from 'react-router-dom';
import { getGeiInventoryVersionsAPI } from 'src/services/restcall';
import { GeiInventoryVersion } from 'src/geiVersion/types';
import { canMutateOperationalVersion, OperationalVersionLoad, readVersionIdFromSearch, resolveOperationalVersion, withVersionQuery } from 'src/geiVersion/display';
import { OperationalMutationSlot, OperationalVersionLoadAlert } from 'src/geiVersion/OperationalGates';
import { isPortfolioAssociate, readRememberedRole } from 'src/auth/portfolioAssociate';
import OperationalVersionBanner from '../GeiVersion/OperationalVersionBanner';
import * as XLSX from 'xlsx';
import {
    InfoCircleOutlined
} from '@ant-design/icons';
import { Card } from 'antd';
import { getOrganizationById } from 'src/store/organization/thunks';

interface UserTableProps {
    getAllEstablishmentTable?: any;
    postResgisterEstablishment?: any;
    putResgisterEstablishment?: any;
    getEstablishmentByCode?: any;
    putActiveEstablishment?: any;
    deleteEstablishmentById?: any;
    getAllGeiInventoryFilter?: any;
    user: UserState;
    getUserByToken?: any;
    getAllEstablishmentTableByUser?: any;
    getGeiInventoryById?: any;
    deleteEstablishmentMethodById?: any;
    getOrganizationById?: any;
    GetSelectableEstablishmentGeiInventoryByOrganizationId?: any;
    getAllGeiEstablishment?: any;
    PostEstablismentGei?: any;
    DeleteEstablishmentGeiInventoryById?: any;
    GetEstablishmentGeiInventoryById?: any;
    getAllEstablishmentByGeiInventoryId?: any;
    postResgisterEstablishmentGeiInventor?: any;
}

type DataIndex = keyof EstablishmentGeiInventoryDataType;
type RequiredMark = boolean | 'optional';
const TGeiEstablishment: React.FC<UserTableProps> = (props: UserTableProps) => {
    interface RouteParams {
        idGei: string;
    }
    const params = useParams<RouteParams>();
    const location = useLocation();
    const operationalVersionId = readVersionIdFromSearch(location.search);
    const [operationalVersion, setOperationalVersion] = useState<GeiInventoryVersion | null>(null);
    const [versionLoad, setVersionLoad] = useState<OperationalVersionLoad>('loading');
    const [versionRetry, setVersionRetry] = useState(0);
    const allowMutations = canMutateOperationalVersion(versionLoad, operationalVersion?.state);
    const structuralMutations = allowMutations && !isPortfolioAssociate(readRememberedRole());
    const dateFormat = 'YYYY-MM-DD';
    const history = useHistory();
    const [form] = Form.useForm();
    const [formValidate] = Form.useForm();
    const [dataTable, setDataTable] = useState<EstablishmentGeiInventoryDataType[]>([]);
    const [searchText, setSearchText] = useState('');
    const searchInput = useRef<InputRef>(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [isModalDeleteOpen, setIsModalDeleteOpen] = useState(false);
    const [isModalValidateUser, setIsModalValidateUse] = useState(false);
    const [isModalValidateInactiveUser, setIsModalValidateInactiveUser] = useState(false);
    const [typeModal, setTypeModal] = useState(true);
    const [selectedRolId, setSelectedRolId] = useState("");
    const [selectedId, setSelectedId] = useState("");
    const [componentSize, setComponentSize] = useState<SizeType | 'default'>('default');
    const { Option } = Select;
    const [type, setType] = useState("");
    const [userData, setUserData] = useState<EstablishmentDataType>();
    const [isFormValidate, setIsFormValidate] = useState(true);
    const [requiredMark, setRequiredMarkType] = useState<RequiredMark>('optional');
    const [typeActive, setTypeActive] = useState(false);
    const [gei, setGei] = useState([]);
    const [inputValue, setInputValue] = useState('');
    const [data, setData] = useState([]);
    const [dataGeiAge, setDataGeiAge] = useState('N/A');
    const [dataGeiUser, setDataGeiUser] = useState('N/A');
    const [dataGeiOrganization, setDataGeiOrganization] = useState('N/A')
    const [pagasize, setPageSize] = useState(5);

    const [searchValue, setSearchValue] = useState('');
    const [options, setOptions] = useState([]);
    const [dataFilter, setDataFilter] = useState([]);
    const [selectDataTable, setSelectDataTable] = useState<EstablishmentDataType[]>([]);

    const [isSelectDataTable, setIsSelectServices] = useState<EstablishmentDataType[]>([]);
    const handleSearchFilter = async (value: string) => {

        setSearchValue(value);
        if (value) {
            const responseData = await props.getAllGeiInventoryFilter(value);
            setDataFilter(responseData);
        } else {
            setDataFilter([]);
        }
    };

    const [pagination, setPagination] = useState<TablePaginationConfig>({
        current: 1,
        pageSize: pagasize,
    });
    const handleExportToExcel = () => {
        const exportData = dataTable.map(item => ({

        }));

        const ws = XLSX.utils.json_to_sheet(exportData);
        const wb = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(wb, ws, 'Instalaciones');

        const excelFileName = 'Instalaciones.xlsx';
        XLSX.writeFile(wb, excelFileName);

        openNotification("Exportación exitosa", `Los datos se han exportado a ${excelFileName}`);
    };

    const handleTableChange = async (pagination: TablePaginationConfig) => {
        setPagination({ ...pagination });

        const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
        setDataTable(responseData.establishmentTable);



    };

    const init = async () => {

        const rol = await props.getUserByToken();
        const responseDataGei = await props.getGeiInventoryById(params.idGei);
        setDataGeiAge(responseDataGei.year)
        setDataGeiUser(responseDataGei.personCharge)
        setDataGeiOrganization(responseDataGei.msIdentity_organization_id)




        
        const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);

        setPagination({
            current: 1,
            pageSize: pagasize,
            total: responseData.totalTable
        })
        setDataTable(responseData.establishmentTable);

    }
    useEffect(() => {
        init();
    }, [location.search]);
    useEffect(() => {
        let cancelled = false;
        const loadVersion = async () => {
            setVersionLoad('loading');
            try {
                const response = await getGeiInventoryVersionsAPI(params.idGei);
                if (cancelled) return;
                const list = response.StatusCode === 200 && Array.isArray(response.Response)
                    ? response.Response as GeiInventoryVersion[]
                    : null;
                const resolved = resolveOperationalVersion(list, operationalVersionId);
                setOperationalVersion(resolved.version);
                setVersionLoad(resolved.load);
            } catch {
                if (cancelled) return;
                setOperationalVersion(null);
                setVersionLoad('error');
            }
        };
        loadVersion();
        return () => { cancelled = true; };
    }, [params.idGei, operationalVersionId, versionRetry]);


    const copyLink = (id: string) => {
        const textarea = document.createElement('textarea');
        textarea.value = process.env.REACT_APP_BASE_URL as string + "/reset-password/" + id;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);
        openNotification("Notificación", "Enlace copiado");
    }


    const handleSearch = async (
        selectedKeys: string[],
    ) => {

        if (props.user.rol == "1879ed5c-573a-44aa-848d-2f3b16a82bfc" || props.user.rol == "ec438afc-63f2-4acf-b1d4-e51df3043190") {
            const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
            setDataTable(responseData.establishmentTable);
        }
        else if (props.user.rol == "83ce86cf-fe89-4eaf-9ea6-20efa405f690") {
            const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
            setDataTable(responseData.establishmentTable);
        }

    };

    const handleReset = async (clearFilters: () => void) => {
        clearFilters();
        setSearchText('');
        if (props.user.rol == "1879ed5c-573a-44aa-848d-2f3b16a82bfc" || props.user.rol == "ec438afc-63f2-4acf-b1d4-e51df3043190") {
            const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
            setDataTable(responseData.establishmentTable);
        }
        else if (props.user.rol == "83ce86cf-fe89-4eaf-9ea6-20efa405f690") {
            const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
            setDataTable(responseData.establishmentTable);

        }
    };

    const gotoActivityData = async (value: any) => {
        const response = await props.GetEstablishmentGeiInventoryById(value);
        history.push(withVersionQuery("/activity/" + response.id + "/" + params.idGei, operationalVersionId))
    };
    //GetEstablishmentGeiInventoryById

    const getColumnSearchProps = (dataIndex: DataIndex, title: string): ColumnType<EstablishmentGeiInventoryDataType> => ({
        filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters }) => (
            <div style={{ padding: 8 }} onKeyDown={e => e.stopPropagation()}>
                <Input
                    ref={searchInput}
                    placeholder={`Buscar ${title}`}
                    value={selectedKeys[0]}
                    onChange={e => setSelectedKeys(e.target.value ? [e.target.value] : [])}
                    onPressEnter={() => handleSearch(selectedKeys as string[])}
                    style={{ marginBottom: 8, display: 'block' }}
                />
                <Space>
                    <Button
                        type="primary"
                        onClick={() => handleSearch(selectedKeys as string[])}
                        icon={<SearchOutlined />}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Buscar
                    </Button>
                    <Button
                        onClick={() => clearFilters && handleReset(clearFilters)}
                        size="small"
                        style={{ width: 90 }}
                    >
                        Reiniciar
                    </Button>
                </Space>
            </div>
        ),
        filterIcon: (filtered: boolean) => (
            <SearchOutlined style={{ color: filtered ? '#1890ff' : undefined }} />
        ),
        onFilter: (value, record) =>
            (record[dataIndex] ?? '')
                .toString()
                .toLowerCase()
                .includes((value as string).toLowerCase()),
        onFilterDropdownOpenChange: visible => {
            if (visible) {
                setTimeout(() => searchInput.current?.select(), 100);
            }
        },

    });

    const [isSort, setIsSort] = useState('NULL');
    const [isSortValue, setIsSortValue] = useState('desc');
    const insertSortResponse = async () => {

        if (isSortValue == "asc") {
            const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
            setDataTable(responseData.establishmentTable);
            setIsSort("asc");
            setIsSortValue("desc")
        } else {

            const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
            setDataTable(responseData.establishmentTable);
            setIsSort("desc");
            setIsSortValue("asc")
        }

    }



    const rowSelection: TableRowSelection<EstablishmentDataType> = {
        onChange: (selectedRowKeys, selectedRows) => {
            console.log(`selectedRowKeys: ${selectedRowKeys}`, 'selectedRows: ', selectedRows);
        },

        onSelect: (record, selected, selectedRows) => {
            setIsSelectServices(selectedRows);

        },
        onSelectAll: (selected, selectedRows, changeRows) => {
            setIsSelectServices(selectedRows);
        },
    };



    const columnsSelect: ColumnsType<EstablishmentDataType> = [
        {
            title: 'Código',
            width: 2,
            dataIndex: 'code',
            key: 'code',
            //...getColumnSearchProps('msIdentityEstablishmentCode', 'code'),
        },

        {
            title: 'Año de apertura',
            width: 2,
            dataIndex: 'openingYear',
            key: 'openingYear',


        },
        {
            title: 'Nombre',
            dataIndex: 'name',
            key: 'name',
            width: 2,
        },


    ];

    const columns: ColumnsType<EstablishmentGeiInventoryDataType> = [
        {
            title: 'Código',
            width: 25,
            dataIndex: 'msIdentityEstablishmentCode',
            key: 'msIdentityEstablishmentCode',
            ...getColumnSearchProps('msIdentityEstablishmentCode', 'msIdentityEstablishmentCode'),
        },

        {
            title: (
                <div>
                    {/* <CaretUpOutlined /> Icono de calendario */}
                    Año de apertura
                    <span onClick={insertSortResponse} style={{ marginLeft: 10, cursor: "pointer" }}> {isSortValue == "desc" ? <CaretDownOutlined /> : <CaretUpOutlined />}</span>
                </div>
            ),
            width: 35,
            dataIndex: 'msIdentityEstablishmentOpeningYear',
            key: 'msIdentityEstablishmentOpeningYear',
            defaultSortOrder: 'descend',

            //sorter: compareAge

            //     const dateA = new Date(a.opening_year);
            //     const dateB = new Date(b.opening_year);

            //     return dateA.getTime() - dateB.getTime();
            // },
        },

        {
            title: 'Nombre',
            dataIndex: 'msIdentityEstablishmentName',
            key: 'msIdentityEstablishmentName',
            width: 50,
        },
        {
            title: 'Formato',
            dataIndex: 'msIdentityEstablishmentType',
            key: 'msIdentityEstablishmentType',
            width: 25,
            //...getColumnSearchProps('organization', 'Organizacion'),
        },
        {
            title: 'Ciudad',
            dataIndex: 'msIdentityEstablishmentCity',
            key: 'msIdentityEstablishmentCity',
            width: 35,
            //...getColumnSearchProps('email', 'correo'),
        },
        // {
        //     title: 'Dirección',
        //     dataIndex: 'address',
        //     key: 'address',
        //     width: 50,
        //     render: (text, record) => (
        //         <span style={{ fontSize: '12px', lineHeight: '0.1' }}>{text}</span>
        //     )
        // },

        // {
        //     title: 'Creado',
        //     dataIndex: 'createdAt',
        //     key: 'createdAt',
        //     width: 25,
        //     defaultSortOrder: 'descend',
        //     sorter: (a, b) => {
        //         const dateA = new Date(a.createdAt);
        //         const dateB = new Date(b.createdAt);

        //         if (isNaN(dateA.getTime())) {
        //             return -1;
        //         }
        //         if (isNaN(dateB.getTime())) {
        //             return 1;
        //         }

        //         return dateA.getTime() - dateB.getTime();
        //     },
        // },


    ];
    const newAction: ColumnType<EstablishmentGeiInventoryDataType> = {
        title: 'Acción',
        key: 'operation',
        fixed: 'right',
        width: 20,

        render: (record: EstablishmentGeiInventoryDataType) =>
            <Space size="middle">
                <Space size="middle">
                    {<Button
                        type="text"
                        className={style["update-button"]}
                        onClick={() => gotoActivityData(record.id)}
                    >
                        Data actividad
                    </Button>}
                </Space>,
                <OperationalMutationSlot allowMutations={structuralMutations}>
                    <Button
                        type="text"
                        className={style["eliminate-button"]}
                        onClick={() => handleTypeDeleteButton(record.id)}
                        icon={<CloseCircleOutlined />}
                    />
                </OperationalMutationSlot>

            </Space>,
    };

    const adminColumns: ColumnsType<EstablishmentGeiInventoryDataType> = [
        ...columns,
        ...[newAction],
    ];
    const clientColumns: ColumnsType<EstablishmentGeiInventoryDataType> = [
        ...columns,
        ...[newAction],
    ];
    const handleOk = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleCancel = () => {
        form.resetFields();
        setIsModalOpen(false);
    };
    const handleDeleteOk = async () => {
        setIsModalDeleteOpen(false);
        await props.deleteEstablishmentById(userData?.id);
        const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
        setDataTable(responseData.establishmentTable);
    };
    const handleValidateUserOk = async () => {
        setIsModalValidateUse(false);
    };

    const handleValidateInactiveUserOk = async () => {

        const registerUser = {
            id: userData?.id,
            geiInventoryId: userData?.id,
            year: "",
            code: "",
            name: "",
            type: "",
            status: "",
            city: "",
            address: ""
        };
        await props.putActiveEstablishment(registerUser);
        const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
        setDataTable(responseData.establishmentTable);
        setIsModalValidateInactiveUser(false);
        handleCancel();
    };
    const handleDeleteCancel = () => {
        setIsModalDeleteOpen(false);
    };
    const handleValidateUserCancel = () => {
        setIsModalValidateUse(false);
    };
    const handleValidateInactiveUserCancel = () => {
        setIsModalValidateInactiveUser(false);
    };
    const onFormLayoutChange = ({ size }: { size: SizeType }) => {
        setComponentSize(size);
    };

    const showModalCreate = async () => {
        const response = await props.GetSelectableEstablishmentGeiInventoryByOrganizationId(dataGeiOrganization, params.idGei);
        setSelectDataTable(response);
        setTypeActive(false);
        setIsFormValidate(true);
        setIsModalOpen(true);
        setTypeModal(true);

    };
    const showModalUpdate = async (value: String) => {


        const responseData: Establishment = await props.getEstablishmentByCode(value);
        if (responseData.status.trim() == "INACTIVE") {
            setTypeActive(true);
        }
        form.setFieldsValue({
            geiInventoryId: responseData.organization_id,
            year: responseData.openingYear,
            code: responseData.code,
            name: responseData.name,
            type: responseData.type,
            msCatalogueCityId: responseData.msCatalogueCityId,
            msCatalogueCityName: responseData.msCatalogueCityName,
            address: responseData.address
        });

        setUserData({
            id: responseData.id,
            organizationId: responseData.organization_id,
            openingYear: responseData.openingYear,
            code: responseData.code,
            name: responseData.name,
            type: responseData.type,
            msCatalogueCityId: responseData.msCatalogueCityId,
            msCatalogueCityName: responseData.msCatalogueCityName,
            address: responseData.address,
            status: responseData.status,
            createdAt: responseData.created_at,

        });
        setIsModalOpen(true);
        setIsFormValidate(false);
        setTypeModal(false);
    };

    const deleteUserTable = async (id: EstablishmentDataType) => {
        setUserData(id)
        setIsModalDeleteOpen(true);

    };


    const insertDataSelectTable = async () => {
        if (isSelectDataTable.length > 0) {
            for (let i = 0; i < isSelectDataTable.length; i++) {
                const registerReceptionService = {
                    MsIdentity_establishment_id: isSelectDataTable[i].id,
                    Gei_inventory_id: params.idGei,
                };
                await props.postResgisterEstablishmentGeiInventor(registerReceptionService);
            }
            //openNotification("Ingreso","Establecimientos "+validateMessages.registerSuccess);  
            const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
            setDataTable(responseData.establishmentTable);
            setIsModalOpen(false);
        } else {
            openNotification("Advertencia", "No se ha seleccionado ningun establecimiento");
        }


    };
    const onFinish = async (values: any) => {


        const register = {
            organizationId: dataGeiOrganization,
            openingYear: values.year,
            code: values.code,
            name: values.name,
            type: values.type,
            status: "ACTIVE",
            city: values.city,
            address: values.address
        };
        handleCancel();
        if (typeModal) {
            await props.postResgisterEstablishment(register);
        } else {
            await props.putResgisterEstablishment(register);
        }
        const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
        setDataTable(responseData.establishmentTable);
        form.resetFields();
    };

    const [isModalDeleteMethodOpen, setIsModalDeleteMethodOpen] = useState(false);
    const [isIdData, setIdData] = useState<String>("");
    const handleDeleteMethodOk = async () => {
        const responseData = await props.DeleteEstablishmentGeiInventoryById(isIdData);
        if (responseData != undefined) {
            const responseData = await props.getAllEstablishmentByGeiInventoryId(pagination.current, pagination.pageSize, params.idGei, "NULL", isSort, operationalVersionId);
            setDataTable(responseData.establishmentTable);
        }

        setIsModalDeleteMethodOpen(false);
    };
    const handleDeleteMethodCancel = () => {
        setIsModalDeleteMethodOpen(false);
    };
    const handleTypeDeleteButton = async (value: String) => {
        setIdData(value);
        setIsModalDeleteMethodOpen(true);

    }

    return (
        <>
            <OperationalVersionLoadAlert load={versionLoad} onRetry={() => setVersionRetry((attempt) => attempt + 1)} />
            <OperationalVersionBanner inventoryYear={dataGeiAge} version={operationalVersion} explicit={operationalVersionId !== null} />
            <Row justify="space-between" align="middle">
                <Col >

                    <OperationalMutationSlot allowMutations={structuralMutations}>
                        <Button
                            type="primary"
                            icon={<PlusCircleOutlined />}
                            className={style["create-button-user"]}
                            onClick={showModalCreate}
                        >
                            Agregar establecimientos
                        </Button>
                    </OperationalMutationSlot>

                    <Button
                        type="primary"
                        icon={<FileExcelOutlined />}
                        style={{ backgroundColor: '#1f71d9', borderColor: 'gray', marginLeft: '8px' }}
                        onClick={handleExportToExcel}
                    >
                        Exportar a Excel
                    </Button>
                </Col>
                <Col>
                    <Card title="Información GEI: " style={{ width: 750, height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <b>Año:  </b>{dataGeiAge}  <b> Responsable: </b> {dataGeiUser}
                    </Card>
                </Col>
            </Row>

            <Table size="small" columns={ adminColumns } dataSource={dataTable} scroll={{ x: 1500 }} pagination={pagination}
                onChange={handleTableChange} />
            <Drawer title={"Selecionar establecimiento"} open={isModalOpen} onClose={handleCancel} width={1000} footer={null}>

                <OperationalMutationSlot allowMutations={structuralMutations}>
                    <Button
                        type="primary"
                        icon={<PlusCircleOutlined />}
                        className={style["create-button-user"]}
                        onClick={insertDataSelectTable}
                    >
                        Agregar establecimientos
                    </Button>
                </OperationalMutationSlot>
                <Table size="small" rowSelection={{ ...rowSelection }} columns={columnsSelect} dataSource={selectDataTable} scroll={{ x: 500 }}
                />

            </Drawer>
            <Modal open={isModalDeleteOpen} onOk={handleDeleteOk} onCancel={handleDeleteCancel}>
                <h3>¿Esta seguro de inactivar el establecimiento {userData?.name} con código {userData?.code}? </h3>
            </Modal>
            <Modal open={isModalDeleteMethodOpen} onOk={handleDeleteMethodOk} onCancel={handleDeleteMethodCancel}>
                <h3>¿Esta seguro que desea eliminar el Establecimiento? </h3>
            </Modal>
            {/* <Modal open={isModalValidateUser} onOk={handleValidateUserOk}  onCancel={handleValidateUserCancel}>
                <h3>El usuario {userData?.fullname} con cédula {userData?.identification} y {userData?.email} ya se encuentra activo </h3>
            </Modal>
            <Modal open={isModalValidateInactiveUser} onOk={handleValidateInactiveUserOk}  onCancel={handleValidateInactiveUserCancel}>
                <h3>El usuario {userData?.fullname} con cédula {userData?.identification} y {userData?.email} se encuentra inactivo. <br/> ¿Deseas activarlo? </h3>
            </Modal> */}

        </>


    );


};

const mapStateToProps = (state: AppState) => ({
    user: state.user
});

export default connect(mapStateToProps, {
    getAllEstablishmentTable, postResgisterEstablishment, putResgisterEstablishment,
    getEstablishmentByCode, putActiveEstablishment, getUserByToken, deleteEstablishmentById,
    getAllGeiInventoryFilter, getAllEstablishmentTableByUser, getAllEstablishmentTableByOrganization,
    getGeiInventoryById, deleteEstablishmentMethodById, getOrganizationById,

    getAllGeiEstablishment, GetSelectableEstablishmentGeiInventoryByOrganizationId,
    PostEstablismentGei, DeleteEstablishmentGeiInventoryById, GetEstablishmentGeiInventoryById,
    getAllEstablishmentByGeiInventoryId, postResgisterEstablishmentGeiInventor
})(TGeiEstablishment);